<template>
	<v-col class="registrasi">
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :type="typeRegis"></ModalSuccess>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">{{ pageTitle }}</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-account-group</v-icon>
			<div class="pl-2">Jaringan</div>
			<div class="px-2">/</div>
			<div>{{ pageTitle }}</div>
		</div>

		<div class="mt-5 mb-3" v-if="!$route.query.id">
			<v-card class="pa-4 elevation-0 rounded-lg" outlined>
				<v-row class="align-center justify-end">
					<v-col cols="12" sm="12" md="6" lg="3"><span class="d-block text-left text-md-right font-weight-bolder cl-secondary">Pilih Mitra yang Anda Sponsori</span></v-col>
					<v-col cols="12" sm="12" md="6" lg="5">
						<v-autocomplete 
							dense 
							flat 
							solo
							background-color="grey lighten-3"
							clearable 
							hide-details="auto" 
							no-data-text="Tidak ada data mitra yang ditemukan" 
							placeholder="Pilih Mitra" 
							color="primary" 
							:items="listMembership" 
							item-text="member_name" 
							item-value="member_id" 
							:filter="customFilter"
							v-model="paramsId" 
							tabindex="0"
							@change="loadDataMitra()"
						>
							<template v-slot:selection="data">
								<div class="d-flex align-center justify-space-between">
									<span class="d-none d-md-block text-capitalize">{{ data.item.member_name }} <span v-if="data.item.member_mobilephone"> ( {{ data.item.member_mobilephone }} )</span></span>
									<span class="d-flex d-md-none flex-column text-capitalize">{{ data.item.member_name }} <small v-if="data.item.member_mobilephone"> ( {{ data.item.member_mobilephone }} )</small></span>
								</div>
							</template>
							<template v-slot:item="data">
								<v-list-item-content>
									<v-list-item-title>
										<div class="d-flex align-center justify-space-between">
											<span class="text-capitalize">{{ data.item.member_name }}</span>
											<span>{{ data.item.member_mobilephone }}</span>
										</div>
									</v-list-item-title>
								</v-list-item-content>
							</template>
						</v-autocomplete>
					</v-col>
				</v-row>
			</v-card>
		</div>

		<template v-if="!loaderData">
			<template v-if="paramsId">
				<template v-if="isMitraExist">	
					<div class="mt-5">
						<v-row>
							<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
								<v-col cols="12" sm="12" md="4" class="align-stretch pt-5">
									<v-form ref="formActivation" role="form">
										<v-row>
											<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3">
												<v-alert dense prominent border="top" type="success" class="mb-3" v-if="params.activation_datetime">
													<div class="d-flex flex-wrap align-center pa-3 fill-height">
														<template v-if="$route.query.id">
															<div class="mb-4 font-weight-700">
																<strong>Akun <strong class="text-uppercase">{{ params.name }}</strong> Telah Aktif!</strong>
															</div>
															<div class="font-size-10">
																Akun telah diproses aktivasi pada <strong class="d-block">{{ params.activation_datetime | tanggaljam }}</strong>
															</div>
														</template>

														<template v-else>
															<div class="mb-4 font-weight-700">
																<strong>Akun Anda Telah Aktif!</strong>
															</div>
															<div class="font-size-10">
																Anda telah melakukan proses aktivasi pada <strong>{{ params.activation_datetime | tanggaljam }}</strong>
															</div>
														</template>
													</div>
												</v-alert>

												<v-card class="pa-4 elevation-0 rounded-lg" outlined>
													<div class="font-size-14 cl-primary">Data Jaringan &amp; Serial</div>
													<template v-if="params.activation_datetime">
														<div class="pt-2">
															<div class="d-block font-size-10 mb-4">
																<div class="d-flex flex-column">
																	<span class="d-flex align-center grey--text">Kode Mitra</span>
																	<span class="font-weight-600 cl-secondary text-capitalize">{{ params.network_code | emptyData }}</span>
																</div>
															</div>
															
															<div class="d-block font-size-10 mb-4">
																<div class="d-flex flex-column">
																	<span class="d-flex align-center grey--text">Kode Sponsor</span>
																	<span class="font-weight-600 cl-secondary text-capitalize">
																		{{ params.sponsor_code | emptyData }}
																		<span class="pt-1 font-size-9" :class="(sponsor_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="sponsor_valid">
																			{{ sponsor_name }}
																		</span>
																	</span>
																</div>
															</div>

															<div class="d-block font-size-10 mb-4">
																<div class="d-flex flex-column">
																	<span class="d-flex align-center grey--text">Kode Upline</span>
																	<span class="font-weight-600 cl-secondary text-capitalize">
																		{{ params.upline_code | emptyData }}
																		<span class="pt-1 font-size-9" :class="(upline_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="upline_valid">
																			{{ upline_name }}
																		</span>
																	</span>
																</div>
															</div>

															<div class="d-block font-size-10 mb-4">
																<div class="d-flex flex-column">
																	<span class="d-flex align-center grey--text">Posisi Jaringan</span>
																	<span class="font-weight-600 cl-secondary text-capitalize">
																		<template v-if="params.position == 'L'"><span class="cl-primary">Kiri</span></template>
																		<template v-else-if="params.position == 'R'"><span class="cl-primary">Kanan</span></template>
																		<template v-else><span class="cl-primary">-</span></template>
																	</span>
																</div>
															</div>
														</div>
													</template>

													<template v-else>
														<template v-if="!isActiveMember">
															<div class="pt-2 mb-0">
																<v-text-field label="Kode Sponsor" color="primary" hide-details="auto" v-model="params.sponsor_code" tabindex="0" ref="sponsor_code" :rules="rules.sponsor_code" @focus="$event.target.select()" @blur="getMitraSponsorName(params.sponsor_code, 'input')"></v-text-field>
																<div class="pt-1 font-size-9" :class="(sponsor_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="sponsor_valid">
																	{{ sponsor_name }}
																</div>
															</div>
														</template>
														<template v-else>
															<div class="d-block font-size-10 pt-2">
																<div class="d-flex flex-column">
																	<span class="d-flex align-center grey--text">Kode Sponsor</span>
																	<span class="font-weight-600 cl-secondary text-capitalize">
																		{{ params.sponsor_code | emptyData }}
																		<span class="pt-1 font-size-9" :class="(sponsor_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="sponsor_valid">
																			{{ sponsor_name }}
																		</span>
																	</span>
																</div>
															</div>
														</template>
														<div class="pt-2">
															<v-text-field label="Kode Upline" ref="upline_code" color="primary" hide-details="auto" v-model="params.upline_code" tabindex="1" :rules="rules.upline_code" @focus="$event.target.select()" @blur="getMitraUplineName(params.upline_code, 'input')"></v-text-field>
															<div class="pt-1 font-size-9" :class="(upline_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="upline_valid">
																{{ upline_name }}
															</div>
														</div>
														<div class="pt-2 pb-0 mt-4">
															<v-card outlined dense class="py-1 px-3 mb-0 elevation-0 rounded-lg">
																<v-card-subtitle class="py-0 pt-2 px-0 font-weight-bold">Posisi jaringan</v-card-subtitle>
																<v-radio-group
																	v-model="params.position"
																	row
																	hide-details="auto"
																	class="mb-2"
																	:rules="rules.position"
																>
																	<v-radio
																		label="Kiri"
																		value="L"
																		ref="positionL"
																		tabindex="2"
																	></v-radio>
																	<v-radio
																		label="Kanan"
																		value="R"
																		ref="positionR"
																	></v-radio>
																</v-radio-group>
															</v-card>
														</div>
														<div class="pt-2 mb-2">
															<v-autocomplete 
																v-model="params.network_serial"
																:items="listSerialActivation"
																color="primary"
																label="Serial Aktivasi"
																hide-details="auto"
																item-text="id"
																item-value="id"
																no-data-text="Tidak ada data"
																tabindex="4"
																class="group-autocomplete"
																:rules="rules.input"
															>
																<template v-slot:selection="data">
																	<span class="gray--text lighten-5">{{ data.item.id }}</span> <span class="cl-secondary ml-2">( {{ data.item.group.toUpperCase() }} )</span>
																</template>
																<template v-slot:item="data">
																	<template v-if="(typeof data.item) !== 'object'">
																		<v-list-item-content v-text="data.item"></v-list-item-content>
																	</template>
																	<template v-else>
																		<v-list-item-content>
																			<v-list-item-title v-html="data.item.id"></v-list-item-title>
																		</v-list-item-content>
																	</template>
																</template>
															</v-autocomplete>
														</div>
													</template>
												</v-card>
											</v-col>
										</v-row>

										<template v-if="!params.activation_datetime">
											<v-card class="pa-3 my-4 elevation-0 rounded-lg" outlined>
												<div class="d-flex flex-row justify-space-between">
													<template v-if="$route.query.id">
														<v-btn text class="mr-2" :loading="btnLoadingProses" @click="goBack()">
															<v-icon dense class="mr-1">mdi-arrow-left</v-icon> Kembali
														</v-btn>

														<v-btn
															color="primary"
															tabindex="5"
															:disabled="(!params.network_serial) ? true : false"
															:loading="btnLoadingProses"
															@click="processInput()"
														>
															<v-icon dense class="mr-1">mdi-account-reactivate-outline</v-icon>
															Aktivasi
														</v-btn>
													</template>

													<template v-else>
														<v-btn
															color="primary"
															tabindex="5"
															block
															:disabled="(!params.network_serial) ? true : false"
															:loading="btnLoadingProses"
															@click="processInput()"
														>
															<v-icon dense class="mr-1">mdi-account-reactivate-outline</v-icon>
															Aktivasi
														</v-btn>
													</template>
												</div>
											</v-card>
										</template>
									</v-form>
								</v-col>
							</v-scroll-x-reverse-transition>

							<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
								<v-col cols="12" sm="12" md="8" class="pt-5">
									<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
										<div class="font-size-12 cl-primary">Data Personal</div>
										<div class="pt-5">
											<v-row>
												<v-col cols="12" sm="12" md="3">
													<div class="text-center">
														<v-img height="100" width="100" class="user-img mx-auto rounded-pill" :src="(stores_image) ? stores_image : 'assets/image/profile-pict.png'"></v-img>
														<div class="bottom-shadow"></div>
													</div>
												</v-col>
												<v-col cols="12" sm="12" md="4" class="px-4">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Lengkap</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.name | emptyData }}</span>
														</div>
													</div>

													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-email</v-icon>Email</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.email | emptyData }}</span>
														</div>
													</div>

													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-card-account-details</v-icon>No. Ktp</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.identity_no | emptyData }}</span>
														</div>
													</div>

													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-cellphone</v-icon>No. Handphone</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.mobilephone | emptyData }}</span>
														</div>
													</div>
												</v-col>

												<v-col cols="12" sm="12" md="5" class="px-4">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-radius-outline</v-icon>Alamat</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.address | emptyData }}</span>
														</div>
													</div>

													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Kota</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ getCityName(params.city_id) }}</span>
														</div>
													</div>

													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Provinsi</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ getProvinceName(params.province_id) }}</span>
														</div>
													</div>
												</v-col>
											</v-row>
										</div>
									</v-card>

									<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
										<div class="font-size-12 cl-primary">Data Ahli Waris</div>
										<div class="pt-5">
											<v-row>
												<v-col cols="12" sm="12" md="4" class="px-0">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Ibu Kandung</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.mother_name | emptyData }}</span>
														</div>
													</div>
												</v-col>

												<v-col cols="12" sm="12" md="4" class="px-0">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Ahli Waris</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.devisor_name | emptyData }}</span>
														</div>
													</div>
												</v-col>

												<v-col cols="12" sm="12" md="4" class="px-0">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Hubungan Ahli Waris</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.devisor_relation | emptyData }}</span>
														</div>
													</div>
												</v-col>
											</v-row>
										</div>
									</v-card>

									<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
										<div class="font-size-12 cl-primary">Data Bank</div>
										<div class="pt-5">
											<v-row>
												<v-col cols="12" sm="12" md="4" class="px-0">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Rekening</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.account_name | emptyData }}</span>
														</div>
													</div>
												</v-col>

												<v-col cols="12" sm="12" md="4" class="px-0">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account-box-outline</v-icon>Nomor Rekening</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.account_no | emptyData }}</span>
														</div>
													</div>
												</v-col>

												<v-col cols="12" sm="12" md="4" class="px-0">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-bank-outline</v-icon>Nama Bank</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.bank_name | emptyData }}</span>
														</div>
													</div>
												</v-col>

												<v-col cols="12" sm="12" md="4" class="px-0">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Kota Bank</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.bank_city_id | emptyData }}</span>
														</div>
													</div>
												</v-col>

												<v-col cols="12" sm="12" md="4" class="px-0">
													<div class="d-block font-size-10 mb-3 px-2">
														<div class="d-flex flex-column">
															<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Nama Cabang</span>
															<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.bank_branch_name | emptyData }}</span>
														</div>
													</div>
												</v-col>
											</v-row>
										</div>
									</v-card>
								</v-col>
							</v-scroll-x-reverse-transition>
						</v-row>
					</div>
				</template>

				<template v-else>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg text-center">
								<NoData></NoData>
								<div class="d-block py-3 text-center cl-secondary">Data Mitra tidak dapat ditemukan.</div>
								<v-btn text class="my-4" :loading="btnLoadingProses" @click="goBack()">
									<v-icon dense class="mr-1">mdi-arrow-left</v-icon> Kembali
								</v-btn>
							</v-card>
						</v-col>
					</v-row>
				</template>
			</template>
		</template>

		<template v-else>
			<LoadData :loading="loaderData" class="mt-5"></LoadData>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSuccess from './components/ModalSuccessActivation'

export default {
	components: {
		ModalSuccess
	},
	data() {
		return {
			loaderData: false,
			loading: false,
			icon: 'mdi-eye',
			btnLoadingProses: false,
			listSerialActivation: [],
			suksesInput: false,
			isActiveMember: false,
			isMitraExist: false,
			stores_image: null,
			paramsId: null,
			pageTitle: 'Aktivasi Mitra',
			sponsor_name: '',
			sponsor_valid: true,
			upline_name: '',
			upline_valid: true,
			params: {
				network_type: 'bin',
				network_code: '',
				sponsor_code: '',
				upline_code: '',
				position: '',
				membership_serial: '',
				network_serial: '',
				name: '',
				identity_no: '',
				email: '',
				mobilephone: '',
				password: '',
				bank_id: '',
				bank_name: '',
				bank_branch_name: '',
				bank_city_id: '',
				account_name: '',
				account_no: '',
				city_id: '',
				province_id: '',
				address: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				activation_datetime: ''
			},
			rules: {
				input: [
					v => !!v || 'Tidak boleh kosong',
				],
				sponsor_code: [
					v => !!v || 'Kode Sponsor tidak boleh kosong',
					v => ( v && this.sponsor_valid ) || "Data mitra tidak ditemukan",
				],
				upline_code: [
					v => !!v || 'Kode Upline tidak boleh kosong',
					v => ( v && this.upline_valid ) || "Data mitra tidak ditemukan",
				],
				position: [
					v => !!v || 'Posisi Jaringan wajib dipilih',
				],
			},
			msgSuccess: '',
			msgFailed: '',
			typeRegis: ''
		}
	},
	watch: {
    // eslint-disable-next-line no-unused-vars
    async $route(to, from) {

			if (to.query.id !== undefined) {
				this.paramsId = await to.query.id
				await this.getProfileData()
			}
			else {
				this.paramsId = await ''
				this.loaderData = false
			}

    }
  },
	computed: {
		...mapState('auth', ['userData']),
		...mapState('registration', ['mitraData', 'responSuksesRegis', 'responseError']),
		...mapState('profile', ['myProfile', 'myBank']),
		...mapState('option', ['optProvince', 'optCity']),
		...mapState('network', ['listMembership']),
	},
	methods: {
		...mapActions('serial', ['getSerialAvailable']),
		...mapActions('registration', ['getMitraByNetworkCode', 'addActivation', 'addActivationMitra', 'resetValidation']),
		...mapActions('option', ['getOptionProvince', 'getOptionCity']),
		...mapActions('profile', ['getMitraData']),
		...mapActions('network', ['getMembership']),

		setSerialData(data) {
			let dataSerial = []
			Object.keys(data).forEach((val) => {
				dataSerial.push({
					header: val.toUpperCase() + ' (' + data[val].length + ')',
				})

				let serial = data[val]
				serial.forEach(item => {
					dataSerial.push({
						id: item.serial_member_stock_serial_id,
						group: val,
						pin: item.serial_member_stock_serial_pin,
						pv: item.serial_member_stock_serial_pv,
						stock_datetime: item.serial_member_stock_datetime,
						exp_datetime: item.serial_member_stock_expired_date,
						isExpired: item.serial_member_stock_is_expired
					})
				});
			})

			return dataSerial
		},

		// eslint-disable-next-line no-unused-vars
		customFilter (item, queryText, itemText) {
			const byName = item.member_name.toLowerCase()
			const byPhone = item.member_mobilephone.toLowerCase()
			const searchText = queryText.toLowerCase()

			return byName.indexOf(searchText) > -1 || byPhone.indexOf(searchText) > -1
		},

		reset() {
			this.params = {
				member_id: '',
				network_code: '',
				sponsor_code: '',
				upline_code: '',
				position: '',
				network_serial: '',
				name: '',
				identity_no: '',
				email: '',
				mobilephone: '',
				bank_id: '',
				bank_name: '',
				bank_branch_name: '',
				bank_city_id: '',
				account_name: '',
				account_no: '',
				city_id: '',
				province_id: '',
				address: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				activation_datetime: ''
			}
		},

		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},

		loadDataMitra() {
			if (this.paramsId) this.getProfileData()
		},

		async getProfileData() {
			if (!this.isActiveMember && this.$route.query.id) this.$router.push({name: 'aktivasi'})
			if (this.$route.query.id !== undefined) this.paramsId = await this.$route.query.id

			if (this.$route.query.id === undefined) this.loaderData = await true

			await this.getMitraData({id: this.paramsId})
				.then((resp) => {
					const response = resp.results.data
					if(Object.keys(response).length == 0) {
						this.isMitraExist = false
					} else {
						if (response.member_sponsor_network_code !== this.userData.bin_network_code) {
							this.isMitraExist = false
						} else {
							this.isMitraExist = true
							this.stores_image = response.member_image_url
							this.params = {
								network_type: 'bin',
								member_id: response.member_id,
								network_code: response.member_network_code,
								sponsor_code: response.member_sponsor_network_code,
								upline_code: response.member_network_upline_network_code,
								position: response.member_network_position,
								network_serial: '',
								name: response.member_name,
								identity_no: response.member_identity_no,
								email: response.member_email,
								mobilephone: response.member_mobilephone,
								bank_id: response.member_bank_id,
								bank_name: response.member_bank_name,
								bank_branch_name: response.member_bank_branch,
								bank_city_id: response.member_bank_city,
								account_name: response.member_bank_account_name,
								account_no: response.member_bank_account_no,
								city_id: response.member_city_id,
								province_id: response.member_province_id,
								address: response.member_address,
								mother_name: response.member_mother_name,
								devisor_name: response.member_devisor_name,
								devisor_relation: response.member_devisor_relation,
								activation_datetime: response.member_activation_datetime
							}

							this.getMitraSponsorName(this.userData.bin_network_code)
	
							// if (this.isActiveMember) {
							// 	this.params.sponsor_code = response.member_sponsor_network_code
								// if (this.$route.query.id) {
									// this.params.sponsor_code = (response.member_network_sponsor_network_code) ? response.member_network_sponsor_network_code : this.userData.bin_network_code
								// } else {
								// 	this.params.sponsor_code = this.userData.bin_network_code
								// }
							// } else {
							// 	this.params.sponsor_code = this.userData.member_sponsor_network_code
							// }
						}
					}

					this.loaderData = false
				})
		},

		getMitraSponsorName(mitra_code) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response.data).length > 0) {
						this.sponsor_name = '[' + response.data.member_name + ']'
						this.sponsor_valid = true
					} else {
						this.sponsor_name = ''
						this.sponsor_valid = false
						setTimeout(() => {
							this.$refs.sponsor_code.focus()
						}, 200);
					}

					this.$refs.formActivation.validate()
				}).catch(() => {
					this.sponsor_name = ''
					this.sponsor_valid = false
				})
			} else {
				this.sponsor_name = ''
				this.sponsor_valid = false
			}
		},

		getMitraUplineName(mitra_code) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response.data).length > 0) {
						this.upline_name = '[' + response.data.member_name + ']'
						this.upline_valid = true
						setTimeout(() => {
							this.$refs.positionL.$el.children[0].children[0].focus()
						}, 200);
					} else {
						this.upline_name = ''
						this.upline_valid = false
						setTimeout(() => {
							this.$refs.upline_code.focus()
						}, 200);
					}

					this.$refs.formActivation.validate()
				}).catch(() => {
					this.upline_name = ''
					this.upline_valid = false
				})
			} else {
				this.upline_name = ''
				this.upline_valid = false
			}
		},

		async getData() {
			await this.getOptionProvince()
			await this.getOptionCity()
			await this.getSerialAvailable().then((response) => {
				const data = response.results.data
				if(response) {
					this.listSerialActivation = this.setSerialData(data.aktivasi)
				}
			})
			await this.getMembership({sort: 'member_join_datetime', dir: 'DESC', limit:100, page: 1})
			if (this.$route.query.id !== undefined) await this.getProfileData()

			setTimeout(() => {
				this.loaderData = false
			}, 600);
		},

		getCityName(id) {
			if(id && Object.keys(this.optCity).length > 0) {
				if(this.optCity[id] !== undefined) {
					return this.optCity[id]
				} else {
					return '-'
				}
			} else {
				return '-'
			}
		},

		getProvinceName(id) {
			if(id && Object.keys(this.optProvince).length > 0) {
				if(this.optProvince[id] !== undefined) {
					return this.optProvince[id]
				} else {
					return '-'
				}
			} else {
				return '-'
			}
		},

		goBack() {
			this.$router.push({name: 'membership'})
		},

		goActivation() {
			this.$router.push({name: 'aktivasi'})
		},

		async processInput() {
			if (this.$refs.formActivation.validate()) {
				this.btnLoadingProses = await true

				this.params.network_type = await 'bin'
				if (this.isActiveMember) {
					this.addActivation(this.params).then(() => {
						this.typeRegis = 'pramitra'
						this.successActivation(this.responSuksesRegis)
						setTimeout(() => {
							this.btnLoadingProses = false
						}, 600);
					}).catch(() => {
						this.loadDataMitra()
						this.btnLoadingProses = false
					})
				} else {
					this.addActivationMitra(this.params).then(() => {
						this.typeRegis = 'mitra'
						this.successActivation(this.responSuksesRegis)
						setTimeout(() => {
							this.btnLoadingProses = false
						}, 600);
					}).catch(() => {
						this.loadDataMitra()
						this.btnLoadingProses = false
					})
				}
				await this.reset()
				this.btnLoadingProses = await false
				this.loaderData = await true
				this.getData()
			}
		},

		successActivation(data) {
			if(data) {
				this.msgSuccess = `
					<span class="font-weight-bold cl-primary font-size-12">Mitra Anda telah berhasil di-aktivasi pada sistem MLM Esoftdream.</span><br>
					<div class="d-block text-center my-4">
						<span class="d-block"><span style="display: inline-block;">Nama Mitra</span> : <strong>${data.name}</strong></span>
						<span class="d-block"><span style="display: inline-block;">Username</span> : <strong>${data.network_code}</strong></span>
					</div>
					Yuk informasikan ke mitra baru Anda untuk segera melengkapi data. Salam sukses bersama <strong>MLM Esoftdream!</strong>
				`
	
				this.$refs.modalSuccess.modalShow()
			}
		}
	},

	async created() {
		if (this.$route.query.id !== undefined) this.loaderData = await true
		else this.loaderData = await false

		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)
		await this.checkMemberActivation(data)
		
		await this.$store.dispatch('setPageTitle', this.pageTitle)
		this.getData()
	}
};
</script>

<style lang="scss" scoped>
	.icon-upload-image {
		margin-top: -3.3rem !important;
		margin-left: 9.5rem !important;
	}
</style>